"use client";

import { c as _c } from "react/compiler-runtime";
import { type EmojiPickerListCategoryHeaderProps, type EmojiPickerListEmojiProps, type EmojiPickerListRowProps, EmojiPicker as EmojiPickerPrimitive } from "frimousse";
import { LoaderIcon, SearchIcon } from "lucide-react";
import type * as React from "react";
import { cn } from "@/lib/utils";
function EmojiPicker(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("bg-popover text-popover-foreground isolate flex h-full w-fit flex-col overflow-hidden rounded-md", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <EmojiPickerPrimitive.Root className={t1} data-slot="emoji-picker" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function EmojiPickerSearch(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex h-9 items-center gap-2 border-b px-3", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SearchIcon className="size-4 shrink-0 opacity-50" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props) {
    t3 = <EmojiPickerPrimitive.Search className="outline-hidden placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm disabled:cursor-not-allowed disabled:opacity-50" data-slot="emoji-picker-search" {...props} />;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={t1} data-slot="emoji-picker-search-wrapper">{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function EmojiPickerRow(t0) {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <div {...props} className="scroll-my-1 px-1" data-slot="emoji-picker-row">{children}</div>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function EmojiPickerEmoji(t0) {
  const $ = _c(10);
  let className;
  let emoji;
  let props;
  if ($[0] !== t0) {
    ({
      emoji,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = emoji;
    $[3] = props;
  } else {
    className = $[1];
    emoji = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("data-[active]:bg-accent flex size-7 items-center justify-center rounded-sm text-base", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== emoji.emoji || $[7] !== props || $[8] !== t1) {
    t2 = <button {...props} className={t1} data-slot="emoji-picker-emoji">{emoji.emoji}</button>;
    $[6] = emoji.emoji;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function EmojiPickerCategoryHeader(t0) {
  const $ = _c(6);
  let category;
  let props;
  if ($[0] !== t0) {
    ({
      category,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = category;
    $[2] = props;
  } else {
    category = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== category.label || $[4] !== props) {
    t1 = <div {...props} className="bg-popover text-muted-foreground px-3 pb-2 pt-3.5 text-xs leading-none" data-slot="emoji-picker-category-header">{category.label}</div>;
    $[3] = category.label;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function EmojiPickerContent(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("outline-hidden relative flex-1", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmojiPickerPrimitive.Loading className="absolute inset-0 flex items-center justify-center text-muted-foreground" data-slot="emoji-picker-loading"><LoaderIcon className="size-4 animate-spin" /></EmojiPickerPrimitive.Loading>;
    t3 = <EmojiPickerPrimitive.Empty className="absolute inset-0 flex items-center justify-center text-muted-foreground text-sm" data-slot="emoji-picker-empty">No emoji found.</EmojiPickerPrimitive.Empty>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmojiPickerPrimitive.List className="select-none pb-1" components={{
      Row: EmojiPickerRow,
      Emoji: EmojiPickerEmoji,
      CategoryHeader: EmojiPickerCategoryHeader
    }} data-slot="emoji-picker-list" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t1) {
    t5 = <EmojiPickerPrimitive.Viewport className={t1} data-slot="emoji-picker-viewport" {...props}>{t2}{t3}{t4}</EmojiPickerPrimitive.Viewport>;
    $[8] = props;
    $[9] = t1;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function EmojiPickerFooter(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("max-w-(--frimousse-viewport-width) flex w-full min-w-0 items-center gap-1 border-t p-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmojiPickerPrimitive.ActiveEmoji>{_temp}</EmojiPickerPrimitive.ActiveEmoji>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <div className={t1} data-slot="emoji-picker-footer" {...props}>{t2}</div>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(t0) {
  const {
    emoji
  } = t0;
  return emoji ? <><div className="flex size-7 flex-none items-center justify-center text-lg">{emoji.emoji}</div><span className="text-secondary-foreground truncate text-xs">{emoji.label}</span></> : <span className="text-muted-foreground ml-1.5 flex h-7 items-center truncate text-xs">Select an emoji…</span>;
}
export { EmojiPicker, EmojiPickerSearch, EmojiPickerContent, EmojiPickerFooter };